import { DataLayer } from "@piwikpro/react-piwik-pro"

export const sendAppDownloadDataLayerPush = (
	downloadMethod: "android" | "ios" | "phonenumber"
) => {
	DataLayer.push({
		event: "app_download",
		download_method: downloadMethod,
	})
}

export const sendDiscoverMoreDataLayerPush = (title: string) => {
	DataLayer.push({
		event: "discover_more_click",
		discover_more_title: title,
	})
}

export const sendJobAdDataLayerPush = (
	action: "apply" | "declare_interest" | "view_ad",
	title: string
) => {
	DataLayer.push({
		event: "job_ad",
		job_action: action,
		job_ad: title,
	})
}

export const sendContactDataLayerPush = (
	type: "phone" | "mail",
	name: string
) => {
	DataLayer.push({
		event: "contact_click",
		contact_type: type,
		contact_name: name,
	})
}
export const sendCtaClickLayerPush = (cta_label: string) => {
	DataLayer.push({
		event: "cta_click",
		cta_click_name: cta_label,
	})
}
export const sendArticleDataLayerPush = (
	action: "saved" | "viewed",
	title: string
) => {
	DataLayer.push({
		event: "article",
		article_action: action,
		article_title: title,
	})
}

export const sendAccordionClickDataLayerPush = (accordion_title: string) => {
	DataLayer.push({
		event: "accordion_click",
		accordion_title: accordion_title,
	})
}

export const sendFastlistingLayerPush = (region: string, care_unit: string) => {
	DataLayer.push({
		event: "fastlisting",
		fastlisting_region: region,
		fastlisting_care_unit: care_unit,
	})
}

export const sendNavigationDataLayerPush = (
	type: "main_menu" | "my_pages_submenu" | "footer",
	clickedItem: string
) => {
	DataLayer.push({
		event: "navigation",
		navigation_type: type,
		navigation_click: clickedItem,
	})
}

export const sendUserLogonDataLayerPush = (user_id: string) => {
	DataLayer.push({
		event: "log_in",
		user_id: user_id,
	})
}

export const sendDeleteAccountDataLayerPush = (user_id: string) => {
	DataLayer.push({
		event: "delete_account",
		user_id: user_id,
	})
}

export const sendUserLogOutDataLayerPush = () => {
	DataLayer.push({
		event: "log_out",
	})
}

export const sendOpenFilterDataLayerPush = (action: "open" | "close") => {
	DataLayer.push({
		event: "filter",
		filter_action: action,
	})
}

export const sendAlertExpandDataLayerPush = (
	title: string,
	isGlobal: boolean,
	messageType: string
) => {
	DataLayer.push({
		event: "banner_message_expand",
		banner_message_title: title,
		banner_alert_type: isGlobal ? "global" : "local",
		banner_message_type: messageType,
	})
}

export const sendVisitedDiagnosesClickDataLayerPush = (title: string) => {
	DataLayer.push({
		event: "visited_diagnoses_click",
		visited_diagnoses_cta: title,
	})
}

export const sendCampaignBlockClickDataLayerPush = (title: string) => {
	DataLayer.push({
		event: "campaign_block_click",
		campaign_block_title: title,
	})
}

export const sendCareerListBlockClickDataLayerPush = (
	title: string,
	location: string
) => {
	DataLayer.push({
		event: "career_list_click",
		career_list_click: title,
		career_list_county: location,
	})
}

export const sendLogInPopUpClickDataLayerPush = (title: string) => {
	DataLayer.push({
		event: "log_in_btn_click",
		log_in_pop_up_cta: title,
	})
}

export const sendCommonSearchesDataLayerPush = (searchString: string) => {
	DataLayer.push({
		event: "search_button_click",
		searches_button: searchString,
	})
}
export const sendInternalSearchDataLayerPush = (
	searchTerm: string,
	hits: number
) => {
	DataLayer.push({
		event: "internal_search",
		search_term: searchTerm,
		total_search_hits: hits,
	})
}
export const sendUnitListingClickDataLayerPush = (
	name: string,
	category: string
) => {
	DataLayer.push({
		event: "unit_listing",
		unit_listing_click: name,
		unit_listing_category: category,
	})
}

export const sendPatientInfoCardDataLayerPush = (title: string, type: string, cta_text: string) => {
	DataLayer.push({
		event: 'patient_info_block_click',
		patient_info_block_click: type,
		patient_info_block_title: title,
		patient_info_block_click_copy: cta_text
	})
}
export const sendImageTextCtaClickLayerPush = (link_url: string) => {
	DataLayer.push({
		event: "image_text_block_click",
		image_text_block_link: link_url,
	})
}
